(function () {
    'use strict';

    run.parts.rackootStyleSwitch = function() {
        const style_switcher = document.getElementById('rackoot__style');
        if (style_switcher !== null) {
            const saveRackootSettingsUrl = GlobalRoutes.rackoots.settings;
            const csrf_name = document.getElementsByName('csrf_name')[0].value;
            const csrf_value = document.getElementsByName('csrf_value')[0].value;
            
            style_switcher.addEventListener('change', function(e) {
                const rackoot_data = document.getElementById('rackoot_data');

                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', rackoot_data.dataset.uuid);
                data.append('style', e.target.value);

                const previous_style = document.body.dataset.rackootStyle;
                document.body.dataset.rackootStyle = e.target.value;

                const bg_selector = document.getElementById('rackoot_bg_change');
                if (e.target.value == 'rackoot') {
                    bg_selector.classList.remove('disabled');
                } else {
                    bg_selector.classList.add('disabled');
                }

                axios.post(saveRackootSettingsUrl, data)
                .then(function (response) {
                    // new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                })
                .catch(function (error) {
                    document.body.dataset.rackootStyle = previous_style;
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
                // setCookie('rackoot_style', e.target.value, 180);
                // setRackootStyle(e.target.value);
            });
        }
    };
})();
